// CSV export utilities with RFC 4180 compliance and Excel compatibility

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
    return '"' + value.replace(/"/g, '""') + '"'
  }
  return value
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function arrayToCSV<T extends Record<string, any>>(
  data: T[],
  columns?: { key: keyof T; label: string }[]
): string {
  if (data.length === 0) return ''

  const cols = columns ?? Object.keys(data[0]).map((key) => ({ key: key as keyof T, label: key as string }))

  const header = cols.map((col) => escapeCSV(col.label)).join(',')

  const rows = data.map((row) =>
    cols.map((col) => escapeCSV(String(row[col.key] ?? ''))).join(',')
  )

  return [header, ...rows].join('\n')
}

export function downloadCSV(csvContent: string, filename: string): void {
  const bom = '\uFEFF'
  const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
